export default __webpack_public_path__ + "static/media/regulatory--motorcycles-only--g1.3599617f.png";